module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f2f2f2;\r\n}\r\n\r\n.row a{\r\n    display:inline-block;\r\n    padding:0px 20px;\r\n}\r\n\r\n.mandatory{\r\n    color:red;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/inspection-report/inspection-form/inspection-form.component.css
// module id = ./src/app/landprocurement/inspection-report/inspection-form/inspection-form.component.css
// module chunks = main